import { makeStyles } from '@material-ui/core';
import DevSecOpsLogoImage from './devsecops-logo.png';

const useStyles = makeStyles({
  image: {
    width: 'auto',
    height: 48,
  },
  l: {
    width: 'auto',
    height: 180,
  },
  xl: {
    width: 'auto',
    height: 240,
  },
});

const DevSecOpsLogo = ({ size }: { size?: 'xl' | 'l' }) => {
  const classes = useStyles();
  return (
    <img
      alt="DevSecOps Logo"
      className={size ? classes[size] : classes.image}
      src={DevSecOpsLogoImage}
    />
  );
};

export default DevSecOpsLogo;
